import {
  PersonMachineContext,
  usePersonData,
  getPersonMachineSnapshot,
} from '~domains/profile/entities/person';

import { AddressSuggestionApiProvider } from '~entities/address-suggestion';

import { ErrorScreen } from '~shared/ui/error-screen';
import { Loader } from '~shared/ui/loader';

import isEmpty from '@tinkoff/utils/is/empty';

import { PersonFlowScreens } from './person-flow-screens';

export const PersonForm = () => {
  const personDataQuery = usePersonData();

  if (personDataQuery.data) {
    const snapshot = isEmpty(personDataQuery.data)
      ? undefined
      : getPersonMachineSnapshot(personDataQuery.data);

    return (
      <AddressSuggestionApiProvider>
        <PersonMachineContext.Provider options={{ snapshot }}>
          <PersonFlowScreens />
        </PersonMachineContext.Provider>
      </AddressSuggestionApiProvider>
    );
  }

  if (personDataQuery.isLoading) {
    return <Loader />;
  }

  if (personDataQuery.isError) {
    return <ErrorScreen message="Failed to load profile data." />;
  }

  return null;
};
